import { ruleConditions } from './rule-conditions.js';
import { buildRuleDependencyGraph } from './rule-dependency-graph.js';
export function findRuleCycle(rules) {
    const rulesByTarget = buildRuleDependencyGraph(rules);
    const state = new Map();
    const stack = [];
    function visit(index) {
        const rule = rules[index];
        if (state.get(index) === 'done')
            return undefined;
        if (state.get(index) === 'visiting') {
            const cycleStart = stack.indexOf(rule.targetFieldId);
            return cycleStart === -1 ? [...stack, rule.targetFieldId] : stack.slice(cycleStart);
        }
        state.set(index, 'visiting');
        stack.push(rule.targetFieldId);
        for (const { fieldId } of ruleConditions(rule)) {
            for (const depIndex of rulesByTarget.get(fieldId) ?? []) {
                const cycle = visit(depIndex);
                if (cycle)
                    return cycle;
            }
        }
        stack.pop();
        state.set(index, 'done');
        return undefined;
    }
    for (let index = 0; index < rules.length; index += 1) {
        const cycle = visit(index);
        if (cycle)
            return cycle;
    }
    return undefined;
}
//# sourceMappingURL=find-rule-cycle.js.map